import { PageHeader } from 'ui/pageHeader';
import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FeatureFlagsTable from './featureFlagsTable';

import { fetchChangeLog, fetchFeatureFlags, saveFeatureFlag, fetchUsers } from '../actions';
import {
  getChangeLog,
  getFeatureFlags,
  getFetching,
  getFetchingChangeLog,
  selectFeatureFlagsObject,
  selectAdminUsersForFormSelect,
} from '../selectors';

const FeatureFlags = () => {
  const dispatch = useDispatch();

  const adminUsers = useSelector(selectAdminUsersForFormSelect);
  const changeLog = useSelector(getChangeLog);
  const featureFlags = useSelector(getFeatureFlags);
  const featureFlagsObject = useSelector(selectFeatureFlagsObject);
  const isFetching = useSelector(getFetching);
  const isfetchingChangeLog = useSelector(getFetchingChangeLog);

  const onSave = useCallback(
    (featureFlag: any, comment: any) => dispatch(saveFeatureFlag(featureFlag, comment)),
    [dispatch],
  );

  const onImport = useCallback(() => dispatch(fetchFeatureFlags()), [dispatch]);

  const onFetchChangelog = useCallback(
    (featureFlag: any) => dispatch(fetchChangeLog(featureFlag)),
    [dispatch],
  );

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchFeatureFlags());
  }, [dispatch]);

  return (
    <>
      <PageHeader>Feature flags</PageHeader>
      <FeatureFlagsTable
        adminUsers={adminUsers}
        changeLog={changeLog}
        data={featureFlags}
        dataObject={featureFlagsObject}
        fetchChangeLog={onFetchChangelog}
        isFetching={isFetching}
        isFetchingChangeLog={isfetchingChangeLog}
        onSave={onSave}
        onImport={onImport}
      />
    </>
  );
};

export default FeatureFlags;
